import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-productionitemsmanager',
  templateUrl: './productionitemsmanager.component.html',
  styleUrls: ['./productionitemsmanager.component.scss']
})
export class ProductionitemsmanagerComponent implements OnInit {

  items: Observable<any[]>;

  constructor(db: AngularFirestore) {
    this.items = db.collection('productionitems').valueChanges();
  }

  ngOnInit() {
  }

}
